import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  ApiService,
  API_BASE,
  AUTH_API_BASE,
  LAMBDA_API_BASE,
  LEGACY_API_BASE,
  LEGACY_AUTH_BASE,
  V4_API_BASE,
} from './api.service';
import { RetryInterceptor } from './retry.interceptor';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [ApiService, { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true }],
})
export class ApiModule {
  static withConfig(options: ApiModuleOptions): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: API_BASE,
          useValue: options.apiBase,
        },
        {
          provide: AUTH_API_BASE,
          useValue: options.authApiBase,
        },
        {
          provide: LAMBDA_API_BASE,
          useValue: options.lambdaApiBase,
        },
        {
          provide: LEGACY_API_BASE,
          useValue: options.legacyApiBase,
        },
        {
          provide: LEGACY_AUTH_BASE,
          useValue: options.legacyAuthBase,
        },
        {
          provide: V4_API_BASE,
          useValue: options.v4ApiBase ?? null,
        },
      ],
    };
  }
}

export interface ApiModuleOptions {
  apiBase: string;
  authApiBase?: string;
  lambdaApiBase?: string;
  legacyApiBase: string;
  legacyAuthBase?: string;
  v4ApiBase?: string;
}
